export default "__VITE_ASSET__D7ckAz9m__"